import React from 'react';
import './ExpertReverse.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import { BsFillCheckCircleFill } from "react-icons/bs";

type ExpertReverseProps = {
    label?: string,
    title: string,
    description: string,
    list?: string[]
    photo: string
}

const ExpertReverse = ({ label, title, description, list, photo }: ExpertReverseProps) => {
    return (
        <section className='section-common expert-section-reverse section-m section-p'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <div className="row align-items-center flex-column-reverse flex-md-row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div className="expert-img-reverse">
                            <img src={photo} alt="zdjęcie specjalisty" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div className="expert-text">
                            <SectionTitle 
                                subTitle={label}
                                title={title}
                                description={description}
                            />

                            <ul>
                               {list && list.map((item, index) => (
                                   <li key={index}>
                                       <BsFillCheckCircleFill />
                                       {item}
                                   </li>
                               ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExpertReverse;